(function () {
    'use strict';

    angular.module("imApp").factory("customsTarifsService", ['$ihttp', function ($ihttp) {
        let service = {
            listTarifs: function (parms) {
                return $ihttp.post({
                    method: 1724,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
